import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Ticket from 'models/ticket/ticket.model';
import { BehaviorSubject } from 'rxjs';
import { ConfigService } from 'services/config/config.service';
import { TicketService } from 'services/ticket/ticket.service';
import { TokenService } from 'services/token/token-service.service';

@Component({
  selector: 'app-sound-list',
  templateUrl: './sound-list.component.html',
  styleUrls: ['./sound-list.component.scss']
})
export class SoundListComponent implements OnInit {
  public instance: Ticket = new Ticket();
  public soundList: string[] = [];
  public refresh: BehaviorSubject<boolean> = new BehaviorSubject(true);
  constructor(
    public dialogRef: MatDialogRef<SoundListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { ticket: Ticket },
    public ticketService: TicketService,
    public tokenService: TokenService,
    public configService: ConfigService,
  ) { 
    this.instance = data.ticket;
  }

  async ngOnInit() {
    this.soundList = await this.ticketService.getSoundList(this.instance.id);
    this.refresh.subscribe(async r => {
      this.soundList = await this.ticketService.getSoundList(this.instance.id);
    });
  }

  ngOnDestroy() {
    this.refresh.complete();
  }

  async delSound(image: string) {
    this.soundList = this.soundList.filter(i => i !== image);
    await this.ticketService.deleteSound(this.instance, image);
    this.soundList = await this.ticketService.getSoundList(this.instance.id);
    this.refresh.next(true);
  }

  soundUrl(image: string) {
    return this.configService.getConfig().apiUrl + "/ticket/sound/" + this.instance.id + "/" + this.tokenService.getIdToken() + "/" + image;
  }
}